var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{attrs:{"variant":"secondary"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }